import { IPagination, IPaginationDTO } from './pagination.model';

export enum BannerEndpoints {
  BANNERS = '/banners',
}

export interface IBanner {
  id: string;
  locale?: IBannerLocale;
  start_date?: string;
  expiration_date?: string;
  active?: boolean;
  position: number;
  web_media?: string;
  mobile_media?: string;
}

export interface ITranslation {
  name: string;
  locale: string;
  title: string;
  description: string;
  link: string;
}

export interface IBannerLocale {
  uk: {
    title: string;
    description: string;
    link: string;
  };
  ru: {
    title: string;
    description: string;
    link: string;
  };
}

// ----------------- DTOs ----------------

export interface IGetBannersListDTO extends Partial<IPaginationDTO> {
  title?: string;
  description?: string;
  start_date?: string;
  expiration_date?: string;
  active?: '0' | '1';
  limit?: number;
}

export interface IReorderBannersDTO {
  items: { id: string; position: number }[];
}

export interface ICreateBannerDTO {
  start_date: string;
  expiration_date: string;
  active: '0' | '1';
  web_media?: Blob;
  mobile_media?: Blob;
  locale: IBannerLocale;
}

// ------------ Responses --------------

export interface IBannerListResponse {
  data: IBanner[];
  meta: IPagination;
}

export interface ICreateBannerResponse {
  data: IBanner;
}
